import { render, staticRenderFns } from "./IndividualApprovalsList.vue?vue&type=template&id=7d6e76de&scoped=true"
import script from "./IndividualApprovalsList.vue?vue&type=script&lang=js"
export * from "./IndividualApprovalsList.vue?vue&type=script&lang=js"
import style0 from "./IndividualApprovalsList.vue?vue&type=style&index=0&id=7d6e76de&prod&scoped=true&lang=css"
import style1 from "./IndividualApprovalsList.vue?vue&type=style&index=1&id=7d6e76de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6e76de",
  null
  
)

export default component.exports